import React, { useCallback, useEffect, useState } from 'react';
import { Price, Token } from '@cryptoalgebra/kim-sdk';
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { DebouncedInput } from '@app/components/DebouncedInput';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';

export interface RangeSelectorPartProps {
  value: string;
  onUserInput: (value: string) => void;
  decrement: () => string;
  increment: () => string;
  decrementDisabled?: boolean;
  incrementDisabled?: boolean;
  label?: string;
  width?: string;
  locked?: boolean;
  initialPrice: Price<Token, Token> | undefined;
  disabled: boolean;
  title: string;
}

const RangeSelectorPart = ({
  value,
  decrement,
  increment,
  decrementDisabled = false,
  incrementDisabled = false,
  locked,
  onUserInput,
  disabled,
  title
}: RangeSelectorPartProps) => {
  const [localUSDValue, setLocalUSDValue] = useState('');
  const [localTokenValue, setLocalTokenValue] = useState('');

  const {
    initialTokenPrice,
    actions: { updateSelectedPreset }
  } = useLiquidityWizardState();

  const handleOnBlur = useCallback(() => {
    onUserInput(localTokenValue);
  }, [localTokenValue, onUserInput]);

  const handleDecrement = useCallback(() => {
    onUserInput(decrement());
  }, [decrement, onUserInput]);

  const handleIncrement = useCallback(() => {
    onUserInput(increment());
  }, [increment, onUserInput]);

  useEffect(() => {
    if (value) {
      setLocalTokenValue(value);

      if (value === '∞') {
        setLocalUSDValue(value);

        return;
      }
    } else if (value === '') {
      setLocalTokenValue('');
      setLocalUSDValue('');
    }
  }, [initialTokenPrice, value]);

  // useEffect(() => {
  //   return () => updateSelectedPreset(null);
  // }, [updateSelectedPreset]);

  return (
    <VStack alignItems="flex-start">
      <Text fontSize="12px" color="neutral.400">
        {title}
      </Text>
      <HStack>
        <Button
          variant="secondary"
          size="xs"
          onClick={handleDecrement}
          disabled={decrementDisabled || disabled}
        >
          -
        </Button>

        <DebouncedInput
          type={'text'}
          amount={localTokenValue}
          textAlign="left"
          disabled={disabled || locked}
          onChange={v => {
            setLocalTokenValue(v);
            updateSelectedPreset(null);
          }}
          onBlur={handleOnBlur}
          placeholder={'0.00'}
        />

        <Button
          variant="secondary"
          size="xs"
          onClick={handleIncrement}
          disabled={incrementDisabled || disabled}
          className="border border-card-border rounded-xl rounded-l-none"
        >
          +
        </Button>
      </HStack>
    </VStack>
  );
};

export default RangeSelectorPart;
